export const getFieldsType = (purposes: number[]) => {
    // TODO: использовать slug вместо id после http://st/BTRIP-379
    const PURPOSE_CONF_EXT = 14;

    if (!purposes || purposes.length === 0) return;
    if (purposes.includes(PURPOSE_CONF_EXT)) return 'conf';

    return 'trip';
};
